<template>
	<a-modal width="55%" title="详情" :visible="visible" centered :destroy-on-close="true" :mask-closable="false"
		:confirm-loading="confirmLoading" :footer="null" @ok="onSubmit" @cancel="onClose">
		<a-descriptions :column="2" title="项目信息">
			<a-descriptions-item label="企业名称">{{ form.companyName }}</a-descriptions-item>
			<a-descriptions-item label="项目名称">{{ form.projectName }}</a-descriptions-item>
			<a-descriptions-item label="项目总投资(万元)">{{ form.investment }}</a-descriptions-item>
			<a-descriptions-item label="项目开始时间">{{ form.startTimeInterva && form.startTimeInterva.split(' ')[0]
			}}</a-descriptions-item>
			<a-descriptions-item label="项目结束时间">{{ form.endTimeInterva && form.endTimeInterva.split(' ')[0]
			}}</a-descriptions-item>
			<a-descriptions-item label="项目负责人">{{ form.projectLinkman }}</a-descriptions-item>
			<a-descriptions-item label="联系电话">{{ form.phone }}</a-descriptions-item>
			<a-descriptions-item label="年研发经费(万元)">{{ form.researchGrant }}</a-descriptions-item>
			<a-descriptions-item label="高新领域">
				<dict-render :dict-obj="dictObjs['research_field']" :text="form.researchField"
					v-if="form.researchField"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="项目阶段">
				<dict-render :dict-obj="dictObjs['projectStage']" :text="form.projectPhase"
					v-if="form.projectPhase"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="项目分类">
				<dict-render :dict-obj="dictObjs['project_type']" :text="form.projectType" v-if="form.projectType"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="行业类型">
				<dict-render :dict-obj="dictObjs['projectType']" :text="form.industry" v-if="form.industry"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="项目需求" :span="2">
				<dict-render :dict-obj="dictObjs['project_demand']" :text="form.projectDemand" v-if="form.projectDemand"></dict-render>
			</a-descriptions-item>
			<a-descriptions-item label="项目概述" :span="2">{{ form.projectView }}</a-descriptions-item>
			<a-descriptions-item label="项目图片" :span="2">
				<img-upload v-model:value="form.picture" :showBtn="false" :disabled="true" />
			</a-descriptions-item>
			<a-descriptions-item label="附件" :span="2">
				<file-upload v-model:value="form.file" :showBtn="false" :disabled="true" />
			</a-descriptions-item>
		</a-descriptions>
	</a-modal>
</template>
<script>
import { formMixin, dictMixin } from "@/mixins";
import DictRender from "@/components/other/DictRender";

export default {
	name: "DetailModal",
	components: {
		DictRender
	},

	mixins: [formMixin, dictMixin],
	data() {
		return {
			dictNames: "projectStage,research_field,project_type,projectType,project_demand",
			form: {
				parentId: null,
			},
		}
	},
}
</script>
<style scoped lang="less">
.pingguInfo {
	-webkit-box-flex: 1;
	-ms-flex: auto;
	flex: auto;
	overflow: hidden;
	color: rgba(0, 0, 0, 0.85);
	font-weight: bold;
	font-size: 16px;
	line-height: 1.5715;
	white-space: nowrap;
	text-overflow: ellipsis;
	margin-bottom: 15px;
}
</style>
